// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCg8eJ2Dl6VVsdqPwSfbv4FwcJETr7U19Q",
    authDomain: "sushirolly-firebase.firebaseapp.com",
    databaseURL: "https://sushirolly-firebase-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "sushirolly-firebase",
    storageBucket: "sushirolly-firebase.appspot.com",
    messagingSenderId: "1064233630149",
    appId: "1:1064233630149:web:7234675c340cde0017b3ac",
    measurementId: "G-RN00BMD8ZW"

  //   apiKey: process.env.REACT_APP_apiKey,
  //   authDomain: process.env.REACT_APP_authDomain,
  //   databaseURL: process.env.REACT_APP_databaseURL,
  //   projectId: process.env.REACT_APP_projectId,
  //   storageBucket: process.env.REACT_APP_storageBucket,
  //   messagingSenderId: process.env.REACT_APP_messagingSenderId,
  //   appId: process.env.REACT_APP_appId,
};

// Initialize Firebase

const firebase = initializeApp(firebaseConfig);
export default firebase;

// export const app = initializeApp(firebaseConfig)
// export const storage = getStorage(app)